import { render, staticRenderFns } from "./CoresUnidade.vue?vue&type=template&id=7bcbdb88&scoped=true"
import script from "./CoresUnidade.vue?vue&type=script&lang=js"
export * from "./CoresUnidade.vue?vue&type=script&lang=js"
import style0 from "./CoresUnidade.vue?vue&type=style&index=0&id=7bcbdb88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcbdb88",
  null
  
)

export default component.exports